<template>
  <div class="upload-passport-credit">
    <div class="d-flex justify-content-center flex-column align-items-center">
      <div class="d-flex flex-column align-items-center">
        <div class="row d-flex justify-content-center text-center">
          <v-loading :isLoading="imgLoading" :height="50" :width="50" :viewbox="'0 0 50 50'" :cx="25" :cy="25" :r="22" :isHeightAuto="true"></v-loading>

          <div v-if="!passport && !imgLoading" class="col-8 upload-section">
            <form enctype="multipart/form-data">
              <input type="file" class="upload-file" @change="onUploadFileChange"/>
            </form>
            <div class="passport-icon">
              <img src="static/assets/images/SuperHote_icons/id.svg" width="80" alt="id card">
            </div>
            <h2>{{ $t("booking.detail.form.upload_password_title") }}</h2>
          </div>
          <div v-if="passport && !imgLoading" class="col-5 passport-card-image">
            <img :src="passport.name" alt="passport" class="img-responsive">
            <div class="remove-image">
              <button class="btn btn-block btn-warning waves-effect waves-classic waves-effect waves-classic" @click.prevent="deleteFile(passport.id)">
                {{ $t("input.replace") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "UploadPassport",
        data () {
          return {
            passport: {},
            imgLoading:  false
          }
        },
        props: [
          'booking'
        ],
        components: {
          VLoading: require('components/loading/loading.vue'),
        },
        methods: {
          async onUploadFileChange(event) {
            this.imgLoading = true;
            await this.$emit('onUploadFileChange', event, 'passport')
          },
          getPassportResource() {
            this.passport = this.booking.resources.find(resource => resource.type === 'passport');
          },
          async deleteFile(id) {
            this.imgLoading = true;
            await this.$emit('removeResource', id)
          }
        },
        mounted() {
          this.getPassportResource();
        },
        watch: {
          async booking(newVal, oldVal) {
            if (newVal.resources !== oldVal.resources) {
              await this.getPassportResource();
              this.imgLoading = false;
            }
          }
        }
    }
</script>



// WEBPACK FOOTER //
// UploadPassport.vue?b20af1c0